import { z } from 'zod';
import { createServiceHttpClient } from '@wit-support/core-ports';
// Contract: app-service `GET /internal/user/{userId}/login-link` (service-to-service).
// Auth: `Authorization: Bearer <APP_API_KEY>` (static shared secret, NOT a user JWT).
// Success: 200 `{ "success": "success", "data": { url, token, expiresAt, locale } }`.
// Errors:  400/404/422 `{ success: "error", error }`, 401/403 `{ status, message }`.
// We only surface `data.url` (the ready-to-send login link, which already embeds the JWT);
// the raw `token` is intentionally NOT exposed as a template variable. Parsing is tolerant of
// extra fields and only requires a valid `data.url`.
const ResponseSchema = z.object({
    data: z.object({ url: z.string().url() }),
});
export const createHttpAuthLinkPort = (opts) => {
    const client = createServiceHttpClient({
        baseUrl: opts.baseUrl,
        ...(opts.apiKey !== undefined && { apiKey: opts.apiKey }),
        ...(opts.fetchFn !== undefined && { fetchFn: opts.fetchFn }),
        ...(opts.timeoutMs !== undefined && { timeoutMs: opts.timeoutMs }),
    });
    return {
        async createLoginLink(input) {
            try {
                const res = await client.get(`/internal/user/${encodeURIComponent(input.witUserId)}/login-link`);
                if (!res.ok)
                    return null;
                const parsed = ResponseSchema.safeParse(await res.json());
                return parsed.success ? { loginUrl: parsed.data.data.url } : null;
            }
            catch {
                // Network error / AbortError (timeout) → fail soft, mirroring the !res.ok path.
                return null;
            }
        },
    };
};
//# sourceMappingURL=auth-link.js.map